var map = {
	"./ResourceModuleRenderer.js": [
		389
	],
	"./Resources.js": [
		2264
	],
	"./legal/privacy-policies.js": [
		4714,
		714
	],
	"./legal/terms-of-use.js": [
		7706,
		706
	],
	"./legal/user-policies.js": [
		7067,
		67
	],
	"./resources/404.js": [
		3947,
		947
	],
	"./resources/busy-trap-movement-vs-progress.js": [
		1388,
		388
	],
	"./resources/counseling-based-on-data-not-just-random-advice.js": [
		4943,
		943
	],
	"./resources/extension-to-traditional-studies-not-a-replacement.js": [
		5181,
		181
	],
	"./resources/fixing-the-problem-from-the-root.js": [
		5438,
		438
	],
	"./resources/how-zeo-turns-activity-into-growth.js": [
		3010,
		10
	],
	"./resources/illusion-of-competence-watching-vs-learning.js": [
		2381,
		381
	],
	"./resources/information-vs-transformation-zeo-difference.js": [
		7054,
		54
	],
	"./resources/introducing-zeroequalone-personalized-guidance-meets-online-learning.js": [
		2058,
		58
	],
	"./resources/real-time-feedback-vs-post-exam-review.js": [
		7871,
		871
	],
	"./resources/role-of-mentorship-in-student-growth.js": [
		6475,
		475
	],
	"./resources/student-as-an-athlete.js": [
		4619,
		619
	],
	"./resources/students-growth-more-than-exams.js": [
		2036,
		36
	],
	"./resources/top-5-benefits-of-guided-learning-over-traditional-methods.js": [
		6431,
		431
	],
	"./resources/why-clarity-matters-more-than-content.js": [
		8293,
		293
	],
	"./resources/why-i-built-zeroequalone.js": [
		7025,
		25
	],
	"./resources/why-self-learning-is-broken-and-why-students-need-supervision-to-succeed.js": [
		7696,
		696
	],
	"./resources/why-we-are-bringing-supervision-back-to-online-learning.js": [
		791,
		791
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4576;
module.exports = webpackAsyncContext;